"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGithubJobIDFromLogs = exports.getGithubStepInfoFromLogs = exports.processLevels = exports.enrichCIEnvFromGithubLogs = exports.getGithubJobNameFromLogs = exports.createGithubLogCache = exports.isGithubWindowsRunner = exports.shouldGetGithubJobID = exports.shouldGetGithubJobDisplayName = exports.isInteractive = exports.getCIProvider = exports.isCI = exports.getCIEnv = exports.getCIMetadata = exports.getCISpanTags = exports.githubWellKnownDiagnosticDirPatternsWin = exports.githubWellKnownDiagnosticDirPatternsUnix = exports.githubWellKnownDiagnosticDirsWin = exports.githubWellKnownDiagnosticDirsUnix = exports.parseLevels = exports.validateLevel = exports.LEVEL_TO_NUMBER = exports.VALID_LEVELS = exports.CI_LEVELS = exports.envDDGithubStepIndex = exports.envDDGithubJobName = exports.CI_ENGINES = void 0;
const fs_1 = __importDefault(require("fs"));
const chalk_1 = __importDefault(require("chalk"));
const upath_1 = __importDefault(require("upath"));
const glob_1 = require("./glob");
const tags_1 = require("./tags");
const user_provided_git_1 = require("./user-provided-git");
const utils_1 = require("./utils");
exports.CI_ENGINES = {
    APPVEYOR: 'appveyor',
    AWSCODEPIPELINE: 'awscodepipeline',
    AZURE: 'azurepipelines',
    BITBUCKET: 'bitbucket',
    BITRISE: 'bitrise',
    BUDDY: 'buddy',
    BUILDKITE: 'buildkite',
    CIRCLECI: 'circleci',
    CODEFRESH: 'codefresh',
    GITHUB: 'github',
    GITLAB: 'gitlab',
    JENKINS: 'jenkins',
    TRAVIS: 'travisci',
    TEAMCITY: 'teamcity',
};
exports.envDDGithubJobName = 'DD_GITHUB_JOB_NAME';
exports.envDDGithubStepIndex = 'DD_GITHUB_STEP_INDEX';
const envJenkinsCustomStageID = 'DD_CUSTOM_STAGE_ID';
// DD_GITHUB_JOB_NAME is an override that is required for adding custom tags and metrics
// to GHA jobs if the 'name' property is used. It's ok for it to be missing in case the name property is not used.
// DD_CUSTOM_STAGE_ID is only present in recent Jenkins plugin versions.
// Also, pipelines without stages lack this env variable
const envAllowedToBeMissing = [exports.envDDGithubJobName, envJenkinsCustomStageID];
exports.CI_LEVELS = {
    PIPELINE: 'pipeline',
    JOB: 'job',
    STAGE: 'stage',
    STEP: 'step',
};
exports.VALID_LEVELS = Object.values(exports.CI_LEVELS);
exports.LEVEL_TO_NUMBER = {
    [exports.CI_LEVELS.PIPELINE]: 0,
    [exports.CI_LEVELS.JOB]: 1,
    [exports.CI_LEVELS.STAGE]: 2,
    [exports.CI_LEVELS.STEP]: 3,
};
/**
 * Validates that the level is a known value and is supported for the current CI provider.
 * Returns an error message string if invalid, or undefined if valid.
 */
const validateLevel = (level) => {
    if (!level || !exports.VALID_LEVELS.includes(level)) {
        return `Level must be one of [${exports.VALID_LEVELS.join(', ')}]`;
    }
    const provider = (0, exports.getCIProvider)();
    const stageProviders = [exports.CI_ENGINES.AZURE, exports.CI_ENGINES.GITLAB, exports.CI_ENGINES.JENKINS];
    if (level === exports.CI_LEVELS.STAGE && !stageProviders.includes(provider)) {
        return `Level '${exports.CI_LEVELS.STAGE}' is only supported for providers [${stageProviders.join(', ')}]`;
    }
    if (level === exports.CI_LEVELS.STAGE && provider === exports.CI_ENGINES.JENKINS && !process.env.DD_CUSTOM_STAGE_ID) {
        return `Level '${exports.CI_LEVELS.STAGE}' for Jenkins requires the Datadog plugin version to be >= 9.2`;
    }
    if (level === exports.CI_LEVELS.STEP && provider !== exports.CI_ENGINES.GITHUB) {
        return `Level '${exports.CI_LEVELS.STEP}' is only supported for provider [${exports.CI_ENGINES.GITHUB}]`;
    }
    return undefined;
};
exports.validateLevel = validateLevel;
/**
 * Parses an additive, comma-separated `--level` value (e.g. "pipeline,stage").
 * Trims each member, drops empties, dedupes, sorts by span depth, and validates
 * every member (known value + provider support). Returns the parsed levels or,
 * if anything is invalid or empty, a single aggregated error message.
 */
const parseLevels = (input) => {
    const parts = (input !== null && input !== void 0 ? input : '')
        .split(',')
        .map((p) => p.trim())
        .filter((p) => p.length > 0);
    const unique = uniq(parts);
    if (unique.length === 0) {
        return { levels: [], error: `Level must be one of [${exports.VALID_LEVELS.join(', ')}]` };
    }
    const errors = uniq(unique.map((p) => (0, exports.validateLevel)(p)).filter((e) => Boolean(e)));
    if (errors.length > 0) {
        return { levels: [], error: errors.join('; ') };
    }
    const levels = unique.sort((a, b) => exports.LEVEL_TO_NUMBER[a] - exports.LEVEL_TO_NUMBER[b]);
    return { levels };
};
exports.parseLevels = parseLevels;
exports.githubWellKnownDiagnosticDirsUnix = [
    '/home/runner/_diag',
    '/home/runner/actions-runner/_diag',
    '/opt/actions-runner/_diag', // self-hosted in some cases
];
exports.githubWellKnownDiagnosticDirsWin = [
    'C:/actions-runner/_diag', // for self-hosted
];
// Glob patterns covering layouts that namespace `_diag` under one or two
// intermediate directories. This includes both observed SaaS layouts
// (<runnerRoot>/cached/_diag pre-2.334.0, <runnerRoot>/cached/<version>/_diag
// since v2.334.0) and hypothetical future layouts that follow the same shape
// without a `cached` wrapper (e.g. <runnerRoot>/<version>/_diag). Depth is
// bounded on purpose: `*` matches a single segment, so no filesystem walk.
exports.githubWellKnownDiagnosticDirPatternsUnix = [
    '/home/runner/actions-runner/*/_diag',
    '/home/runner/actions-runner/*/*/_diag',
];
exports.githubWellKnownDiagnosticDirPatternsWin = ['C:/actions-runner/*/_diag', 'C:/actions-runner/*/*/_diag'];
const githubJobDisplayNameRegex = /"jobDisplayName":\s*"((?:[^"\\]|\\.)*)"/;
const githubJodIDRegex = /"job":\s*{[\s\S]*?"v"\s*:\s*(\d+)(?:\.0)?/;
/**
 * Properly unescape a JSON string value by leveraging JSON.parse
 * Handles all JSON escape sequences: \", \\, \n, \r, \t, \f, \b, \uXXXX
 *
 * @param str - The JSON-escaped string (without surrounding quotes)
 * @returns The unescaped string
 */
const unescapeJsonString = (str) => {
    try {
        return JSON.parse('"' + str + '"');
    }
    catch (e) {
        // If JSON.parse fails, return as-is
        // This handles edge cases where the string might be malformed
        return str;
    }
};
const uniq = (items) => Array.from(new Set(items));
/**
 * GitHub runner diagnostic logs live under the runner installation directory in `_diag`.
 * On many runners, we can derive the installation directory from RUNNER_TEMP:
 *   <runnerRoot>/_work/_temp  ->  <runnerRoot>/_diag
 *
 * This is much more robust than relying on hardcoded paths, especially on self-hosted runners
 * and GHES environments where the runner may be installed under arbitrary directories/users.
 */
const getGithubDiagnosticDirsFromEnv = () => {
    const dirs = [];
    const runnerTemp = process.env.RUNNER_TEMP;
    if (runnerTemp) {
        // RUNNER_TEMP is typically: <runnerRoot>/_work/_temp
        const runnerRoot = upath_1.default.resolve(runnerTemp, '..', '..');
        // Bounded-depth patterns cover every runner layout we've observed
        // (including cached/<version>/_diag) without assuming a `cached` wrapper
        // and without walking the whole tree.
        dirs.push(`${runnerRoot}/*/_diag`);
        dirs.push(`${runnerRoot}/*/*/_diag`);
        dirs.push(upath_1.default.join(runnerRoot, '_diag'));
        dirs.push(`${runnerRoot}/actions-runner/*/_diag`);
        dirs.push(`${runnerRoot}/actions-runner/*/*/_diag`);
        dirs.push(upath_1.default.join(runnerRoot, 'actions-runner', '_diag'));
    }
    const home = process.env.HOME;
    if (home) {
        dirs.push(upath_1.default.join(home, '_diag'));
        dirs.push(upath_1.default.join(home, 'actions-runner', '_diag'));
    }
    return uniq(dirs.filter(Boolean));
};
/**
 * Expands a mixed list of literal directories and glob patterns into concrete
 * directories. Literals pass through unchanged (existence is checked later).
 */
const expandDiagnosticDirCandidates = (candidates) => {
    const expanded = [];
    for (const candidate of candidates) {
        if ((0, glob_1.hasMagic)(candidate)) {
            try {
                expanded.push(...(0, glob_1.globSync)(candidate));
            }
            catch (_a) {
                // If the glob walk fails for any reason (permissions, etc.), skip.
            }
        }
        else {
            expanded.push(candidate);
        }
    }
    return uniq(expanded);
};
// Receives a string with the form 'John Doe <john.doe@gmail.com>'
// and returns { name: 'John Doe', email: 'john.doe@gmail.com' }
const parseEmailAndName = (emailAndName) => {
    if (!emailAndName) {
        return { name: '', email: '' };
    }
    let name = '';
    let email = '';
    const matchNameAndEmail = emailAndName.match(/(?:"?([^"]*)"?\s)?(?:<?(.+@[^>]+)>?)/);
    if (matchNameAndEmail) {
        name = matchNameAndEmail[1];
        email = matchNameAndEmail[2];
    }
    return { name, email };
};
const resolveTilde = (filePath) => {
    var _a;
    if (!filePath || typeof filePath !== 'string') {
        return '';
    }
    // '~/folder/path' or '~'
    if (filePath[0] === '~' && (filePath[1] === '/' || filePath.length === 1)) {
        return filePath.replace('~', (_a = process.env.HOME) !== null && _a !== void 0 ? _a : '');
    }
    return filePath;
};
const getCISpanTags = (fallbackGithubJobName, fallbackGithubJobID) => {
    var _a, _b, _c, _d, _e, _f, _g;
    const env = process.env;
    let tags = {};
    if (env.DRONE) {
        const { DRONE_BUILD_NUMBER, DRONE_BUILD_LINK, DRONE_STEP_NAME, DRONE_STAGE_NAME, DRONE_WORKSPACE, DRONE_GIT_HTTP_URL, DRONE_COMMIT_SHA, DRONE_BRANCH, DRONE_TAG, DRONE_COMMIT_AUTHOR_NAME, DRONE_COMMIT_AUTHOR_EMAIL, DRONE_COMMIT_MESSAGE, DRONE_PULL_REQUEST, DRONE_TARGET_BRANCH, } = env;
        tags = {
            [tags_1.CI_PROVIDER_NAME]: 'drone',
            [tags_1.CI_PIPELINE_NUMBER]: DRONE_BUILD_NUMBER,
            [tags_1.CI_PIPELINE_URL]: DRONE_BUILD_LINK,
            [tags_1.CI_JOB_NAME]: DRONE_STEP_NAME,
            [tags_1.CI_STAGE_NAME]: DRONE_STAGE_NAME,
            [tags_1.CI_WORKSPACE_PATH]: DRONE_WORKSPACE,
            [tags_1.GIT_REPOSITORY_URL]: DRONE_GIT_HTTP_URL,
            [tags_1.GIT_SHA]: DRONE_COMMIT_SHA,
            [tags_1.GIT_BRANCH]: DRONE_BRANCH,
            [tags_1.GIT_TAG]: DRONE_TAG,
            [tags_1.GIT_COMMIT_AUTHOR_NAME]: DRONE_COMMIT_AUTHOR_NAME,
            [tags_1.GIT_COMMIT_AUTHOR_EMAIL]: DRONE_COMMIT_AUTHOR_EMAIL,
            [tags_1.GIT_COMMIT_MESSAGE]: DRONE_COMMIT_MESSAGE,
        };
        if (DRONE_PULL_REQUEST) {
            tags[tags_1.PR_NUMBER] = DRONE_PULL_REQUEST;
            tags[tags_1.GIT_PULL_REQUEST_BASE_BRANCH] = DRONE_TARGET_BRANCH;
        }
    }
    if (env.CIRCLECI) {
        const { CIRCLE_BUILD_NUM, CIRCLE_WORKFLOW_ID, CIRCLE_PROJECT_REPONAME, CIRCLE_BUILD_URL, CIRCLE_WORKING_DIRECTORY, CIRCLE_BRANCH, CIRCLE_TAG, CIRCLE_SHA1, CIRCLE_REPOSITORY_URL, CIRCLE_JOB, CIRCLE_PR_NUMBER, CIRCLE_PULL_REQUEST, } = env;
        const pipelineUrl = `https://app.circleci.com/pipelines/workflows/${CIRCLE_WORKFLOW_ID}`;
        tags = {
            [tags_1.CI_JOB_URL]: CIRCLE_BUILD_URL,
            [tags_1.CI_JOB_ID]: CIRCLE_BUILD_NUM,
            [tags_1.CI_PIPELINE_ID]: CIRCLE_WORKFLOW_ID,
            [tags_1.CI_PIPELINE_NAME]: CIRCLE_PROJECT_REPONAME,
            [tags_1.CI_PIPELINE_URL]: pipelineUrl,
            [tags_1.CI_JOB_NAME]: CIRCLE_JOB,
            [tags_1.CI_PROVIDER_NAME]: exports.CI_ENGINES.CIRCLECI,
            [tags_1.CI_WORKSPACE_PATH]: CIRCLE_WORKING_DIRECTORY,
            [tags_1.GIT_SHA]: CIRCLE_SHA1,
            [tags_1.GIT_REPOSITORY_URL]: CIRCLE_REPOSITORY_URL,
            [tags_1.GIT_TAG]: CIRCLE_TAG,
            [tags_1.GIT_BRANCH]: CIRCLE_BRANCH,
            [tags_1.CI_ENV_VARS]: JSON.stringify({
                CIRCLE_WORKFLOW_ID,
                // Snapshots are generated automatically and are sort sensitive
                CIRCLE_BUILD_NUM,
            }),
        };
        if (CIRCLE_PR_NUMBER || CIRCLE_PULL_REQUEST) {
            tags[tags_1.PR_NUMBER] = CIRCLE_PR_NUMBER || (CIRCLE_PULL_REQUEST === null || CIRCLE_PULL_REQUEST === void 0 ? void 0 : CIRCLE_PULL_REQUEST.split('/').pop());
        }
    }
    if (env.TRAVIS) {
        const { TRAVIS_PULL_REQUEST_BRANCH, TRAVIS_BRANCH, TRAVIS_COMMIT, TRAVIS_REPO_SLUG, TRAVIS_TAG, TRAVIS_JOB_WEB_URL, TRAVIS_BUILD_ID, TRAVIS_BUILD_NUMBER, TRAVIS_BUILD_WEB_URL, TRAVIS_BUILD_DIR, TRAVIS_COMMIT_MESSAGE, TRAVIS_EVENT_TYPE, TRAVIS_PULL_REQUEST, TRAVIS_PULL_REQUEST_SHA, } = env;
        tags = {
            [tags_1.CI_JOB_URL]: TRAVIS_JOB_WEB_URL,
            [tags_1.CI_PIPELINE_ID]: TRAVIS_BUILD_ID,
            [tags_1.CI_PIPELINE_NAME]: TRAVIS_REPO_SLUG,
            [tags_1.CI_PIPELINE_NUMBER]: TRAVIS_BUILD_NUMBER,
            [tags_1.CI_PIPELINE_URL]: TRAVIS_BUILD_WEB_URL,
            [tags_1.CI_PROVIDER_NAME]: exports.CI_ENGINES.TRAVIS,
            [tags_1.CI_WORKSPACE_PATH]: TRAVIS_BUILD_DIR,
            [tags_1.GIT_SHA]: TRAVIS_COMMIT,
            [tags_1.GIT_TAG]: TRAVIS_TAG,
            [tags_1.GIT_BRANCH]: TRAVIS_PULL_REQUEST_BRANCH || TRAVIS_BRANCH,
            [tags_1.GIT_REPOSITORY_URL]: `https://github.com/${TRAVIS_REPO_SLUG}.git`,
            [tags_1.GIT_COMMIT_MESSAGE]: TRAVIS_COMMIT_MESSAGE,
        };
        if (TRAVIS_EVENT_TYPE === 'pull_request') {
            tags[tags_1.PR_NUMBER] = TRAVIS_PULL_REQUEST;
            tags[tags_1.GIT_PULL_REQUEST_BASE_BRANCH] = (0, utils_1.normalizeRef)(TRAVIS_BRANCH);
            tags[tags_1.GIT_HEAD_SHA] = TRAVIS_PULL_REQUEST_SHA;
        }
    }
    if (env.GITLAB_CI) {
        const { CI_PIPELINE_ID: GITLAB_CI_PIPELINE_ID, CI_PROJECT_PATH, CI_PIPELINE_IID, CI_PIPELINE_URL: GITLAB_CI_PIPELINE_URL, CI_PROJECT_DIR, CI_COMMIT_REF_NAME, CI_COMMIT_TAG, CI_COMMIT_SHA, CI_REPOSITORY_URL, CI_JOB_URL: GITLAB_CI_JOB_URL, CI_JOB_STAGE, CI_JOB_NAME: GITLAB_CI_JOB_NAME, CI_COMMIT_MESSAGE, CI_COMMIT_TIMESTAMP, CI_COMMIT_AUTHOR, CI_JOB_ID: GITLAB_CI_JOB_ID, CI_PROJECT_URL: GITLAB_CI_PROJECT_URL, CI_RUNNER_ID, CI_RUNNER_TAGS, CI_MERGE_REQUEST_IID, CI_MERGE_REQUEST_TARGET_BRANCH_NAME, CI_MERGE_REQUEST_SOURCE_BRANCH_SHA, CI_MERGE_REQUEST_DIFF_BASE_SHA, CI_MERGE_REQUEST_TARGET_BRANCH_SHA, } = env;
        const { name, email } = parseEmailAndName(CI_COMMIT_AUTHOR);
        tags = {
            [tags_1.CI_JOB_NAME]: GITLAB_CI_JOB_NAME,
            [tags_1.CI_JOB_URL]: GITLAB_CI_JOB_URL,
            [tags_1.CI_JOB_ID]: GITLAB_CI_JOB_ID,
            [tags_1.CI_PIPELINE_ID]: GITLAB_CI_PIPELINE_ID,
            [tags_1.CI_PIPELINE_NAME]: CI_PROJECT_PATH,
            [tags_1.CI_PIPELINE_NUMBER]: CI_PIPELINE_IID,
            [tags_1.CI_PIPELINE_URL]: GITLAB_CI_PIPELINE_URL,
            [tags_1.CI_PROVIDER_NAME]: exports.CI_ENGINES.GITLAB,
            [tags_1.CI_WORKSPACE_PATH]: CI_PROJECT_DIR,
            [tags_1.CI_STAGE_NAME]: CI_JOB_STAGE,
            [tags_1.GIT_BRANCH]: CI_COMMIT_REF_NAME,
            [tags_1.GIT_SHA]: CI_COMMIT_SHA,
            [tags_1.GIT_REPOSITORY_URL]: CI_REPOSITORY_URL,
            [tags_1.GIT_TAG]: CI_COMMIT_TAG,
            [tags_1.GIT_COMMIT_MESSAGE]: CI_COMMIT_MESSAGE,
            [tags_1.GIT_COMMIT_AUTHOR_NAME]: name,
            [tags_1.GIT_COMMIT_AUTHOR_EMAIL]: email,
            [tags_1.GIT_COMMIT_AUTHOR_DATE]: CI_COMMIT_TIMESTAMP,
            [tags_1.CI_ENV_VARS]: JSON.stringify({
                CI_PROJECT_URL: GITLAB_CI_PROJECT_URL,
                // Snapshots are generated automatically and are sort sensitive
                CI_PIPELINE_ID: GITLAB_CI_PIPELINE_ID,
                CI_JOB_ID: GITLAB_CI_JOB_ID,
            }),
            [tags_1.CI_NODE_LABELS]: CI_RUNNER_TAGS,
            [tags_1.CI_NODE_NAME]: CI_RUNNER_ID,
        };
        if (CI_MERGE_REQUEST_IID) {
            tags[tags_1.PR_NUMBER] = CI_MERGE_REQUEST_IID;
            tags[tags_1.GIT_PULL_REQUEST_BASE_BRANCH] = CI_MERGE_REQUEST_TARGET_BRANCH_NAME;
            tags[tags_1.GIT_PULL_REQUEST_BASE_BRANCH_SHA] = CI_MERGE_REQUEST_DIFF_BASE_SHA;
            tags[tags_1.GIT_PULL_REQUEST_BASE_BRANCH_HEAD_SHA] = CI_MERGE_REQUEST_TARGET_BRANCH_SHA;
            tags[tags_1.GIT_HEAD_SHA] = CI_MERGE_REQUEST_SOURCE_BRANCH_SHA;
        }
    }
    if (env.GITHUB_ACTIONS || env.GITHUB_ACTION) {
        const { GITHUB_RUN_ID, GITHUB_WORKFLOW, GITHUB_RUN_NUMBER, GITHUB_WORKSPACE, GITHUB_HEAD_REF, GITHUB_JOB, GITHUB_REF, GITHUB_SHA, GITHUB_REPOSITORY, GITHUB_SERVER_URL, GITHUB_RUN_ATTEMPT, DD_GITHUB_JOB_NAME, GITHUB_BASE_REF, JOB_CHECK_RUN_ID, } = env;
        const repositoryUrl = `${GITHUB_SERVER_URL}/${GITHUB_REPOSITORY}.git`;
        let pipelineURL = `${GITHUB_SERVER_URL}/${GITHUB_REPOSITORY}/actions/runs/${GITHUB_RUN_ID}`;
        // Some older versions of enterprise might not have this yet.
        if (GITHUB_RUN_ATTEMPT) {
            pipelineURL += `/attempts/${GITHUB_RUN_ATTEMPT}`;
        }
        // GitHub exposes the numeric job ID via JOB_CHECK_RUN_ID. Prefer it over the
        // log-scraped fallback when available.
        const githubJobID = JOB_CHECK_RUN_ID !== null && JOB_CHECK_RUN_ID !== void 0 ? JOB_CHECK_RUN_ID : fallbackGithubJobID;
        tags = {
            [tags_1.CI_JOB_NAME]: GITHUB_JOB,
            [tags_1.CI_JOB_ID]: githubJobID !== null && githubJobID !== void 0 ? githubJobID : GITHUB_JOB,
            [tags_1.CI_JOB_URL]: (0, utils_1.filterSensitiveInfoFromRepository)(githubJobID
                ? `${GITHUB_SERVER_URL}/${GITHUB_REPOSITORY}/actions/runs/${GITHUB_RUN_ID}/job/${githubJobID}`
                : `${GITHUB_SERVER_URL}/${GITHUB_REPOSITORY}/commit/${GITHUB_SHA}/checks`),
            [tags_1.CI_PIPELINE_ID]: GITHUB_RUN_ID,
            [tags_1.CI_PIPELINE_NAME]: GITHUB_WORKFLOW,
            [tags_1.CI_PIPELINE_NUMBER]: GITHUB_RUN_NUMBER,
            [tags_1.CI_PIPELINE_URL]: (0, utils_1.filterSensitiveInfoFromRepository)(pipelineURL),
            [tags_1.CI_PROVIDER_NAME]: exports.CI_ENGINES.GITHUB,
            [tags_1.CI_WORKSPACE_PATH]: GITHUB_WORKSPACE,
            [tags_1.GIT_SHA]: GITHUB_SHA,
            [tags_1.GIT_REPOSITORY_URL]: repositoryUrl,
            [tags_1.GIT_BRANCH]: GITHUB_HEAD_REF || GITHUB_REF || '',
            [tags_1.CI_ENV_VARS]: JSON.stringify({
                GITHUB_SERVER_URL: (0, utils_1.filterSensitiveInfoFromRepository)(GITHUB_SERVER_URL),
                // Snapshots are generated automatically and are sort sensitive
                GITHUB_REPOSITORY,
                GITHUB_RUN_ID,
                GITHUB_RUN_ATTEMPT,
                DD_GITHUB_JOB_NAME: DD_GITHUB_JOB_NAME !== null && DD_GITHUB_JOB_NAME !== void 0 ? DD_GITHUB_JOB_NAME : fallbackGithubJobName,
            }),
        };
        if (GITHUB_BASE_REF) {
            // GITHUB_BASE_REF is defined if it's a pull_request or pull_request_target trigger
            tags[tags_1.GIT_PULL_REQUEST_BASE_BRANCH] = GITHUB_BASE_REF;
            try {
                const eventPayload = (0, utils_1.getGitHubEventPayload)();
                tags[tags_1.GIT_HEAD_SHA] = (_b = (_a = eventPayload === null || eventPayload === void 0 ? void 0 : eventPayload.pull_request) === null || _a === void 0 ? void 0 : _a.head) === null || _b === void 0 ? void 0 : _b.sha;
                tags[tags_1.GIT_PULL_REQUEST_BASE_BRANCH_HEAD_SHA] = (_d = (_c = eventPayload === null || eventPayload === void 0 ? void 0 : eventPayload.pull_request) === null || _c === void 0 ? void 0 : _c.base) === null || _d === void 0 ? void 0 : _d.sha;
                tags[tags_1.PR_NUMBER] = (_f = (_e = eventPayload === null || eventPayload === void 0 ? void 0 : eventPayload.pull_request) === null || _e === void 0 ? void 0 : _e.number) === null || _f === void 0 ? void 0 : _f.toString();
            }
            catch (e) {
                // ignore malformed event content
            }
        }
    }
    if (env.JENKINS_URL) {
        const { WORKSPACE, BUILD_TAG, JOB_NAME, BUILD_NUMBER, BUILD_URL, GIT_BRANCH: JENKINS_GIT_BRANCH, GIT_COMMIT, GIT_URL, GIT_URL_1, DD_CUSTOM_TRACE_ID, DD_CUSTOM_PARENT_ID, NODE_NAME, NODE_LABELS, CHANGE_ID, CHANGE_TARGET, } = env;
        tags = {
            [tags_1.CI_PIPELINE_ID]: BUILD_TAG,
            [tags_1.CI_PIPELINE_NUMBER]: BUILD_NUMBER,
            [tags_1.CI_PIPELINE_URL]: BUILD_URL,
            [tags_1.CI_PROVIDER_NAME]: exports.CI_ENGINES.JENKINS,
            [tags_1.CI_WORKSPACE_PATH]: WORKSPACE,
            [tags_1.GIT_SHA]: GIT_COMMIT,
            [tags_1.GIT_REPOSITORY_URL]: GIT_URL || GIT_URL_1,
            [tags_1.GIT_BRANCH]: JENKINS_GIT_BRANCH,
            [tags_1.CI_NODE_NAME]: NODE_NAME,
            [tags_1.CI_ENV_VARS]: JSON.stringify({
                DD_CUSTOM_TRACE_ID,
                DD_CUSTOM_PARENT_ID,
            }),
        };
        if (NODE_LABELS) {
            let nodeLabels;
            try {
                nodeLabels = JSON.stringify(NODE_LABELS.split(' '));
                tags[tags_1.CI_NODE_LABELS] = nodeLabels;
            }
            catch (e) {
                // ignore errors
            }
        }
        let finalPipelineName = '';
        if (JOB_NAME) {
            // Job names can contain parameters, e.g. jobName/KEY1=VALUE1,KEY2=VALUE2/branchName
            const jobNameAndParams = JOB_NAME.split('/');
            if (jobNameAndParams.length > 1 && jobNameAndParams[1].includes('=')) {
                finalPipelineName = jobNameAndParams[0];
            }
            else {
                const normalizedBranch = (0, utils_1.normalizeRef)(JENKINS_GIT_BRANCH);
                finalPipelineName = JOB_NAME.replace(`/${normalizedBranch}`, '');
            }
            tags[tags_1.CI_PIPELINE_NAME] = finalPipelineName;
        }
        if (CHANGE_ID) {
            tags[tags_1.PR_NUMBER] = CHANGE_ID;
            tags[tags_1.GIT_PULL_REQUEST_BASE_BRANCH] = CHANGE_TARGET;
        }
    }
    if (env.BUILDKITE) {
        const { BUILDKITE_AGENT_ID, BUILDKITE_BRANCH, BUILDKITE_COMMIT, BUILDKITE_REPO, BUILDKITE_TAG, BUILDKITE_BUILD_ID, BUILDKITE_PIPELINE_SLUG, BUILDKITE_BUILD_NUMBER, BUILDKITE_BUILD_URL, BUILDKITE_JOB_ID, BUILDKITE_BUILD_CHECKOUT_PATH, BUILDKITE_BUILD_AUTHOR, BUILDKITE_BUILD_AUTHOR_EMAIL, BUILDKITE_MESSAGE, BUILDKITE_PULL_REQUEST, BUILDKITE_PULL_REQUEST_BASE_BRANCH, } = env;
        const extraTags = Object.keys(env)
            .filter((envVar) => envVar.startsWith('BUILDKITE_AGENT_META_DATA_'))
            .map((metadataKey) => {
            const key = metadataKey.replace('BUILDKITE_AGENT_META_DATA_', '').toLowerCase();
            return `${key}:${env[metadataKey]}`;
        });
        tags = {
            [tags_1.CI_NODE_NAME]: BUILDKITE_AGENT_ID,
            [tags_1.CI_PROVIDER_NAME]: exports.CI_ENGINES.BUILDKITE,
            [tags_1.CI_PIPELINE_ID]: BUILDKITE_BUILD_ID,
            [tags_1.CI_PIPELINE_NAME]: BUILDKITE_PIPELINE_SLUG,
            [tags_1.CI_PIPELINE_NUMBER]: BUILDKITE_BUILD_NUMBER,
            [tags_1.CI_PIPELINE_URL]: BUILDKITE_BUILD_URL,
            [tags_1.CI_JOB_URL]: `${BUILDKITE_BUILD_URL}#${BUILDKITE_JOB_ID}`,
            [tags_1.CI_JOB_ID]: BUILDKITE_JOB_ID,
            [tags_1.GIT_SHA]: BUILDKITE_COMMIT,
            [tags_1.CI_WORKSPACE_PATH]: BUILDKITE_BUILD_CHECKOUT_PATH,
            [tags_1.GIT_REPOSITORY_URL]: BUILDKITE_REPO,
            [tags_1.GIT_TAG]: BUILDKITE_TAG,
            [tags_1.GIT_BRANCH]: BUILDKITE_BRANCH,
            [tags_1.GIT_COMMIT_AUTHOR_NAME]: BUILDKITE_BUILD_AUTHOR,
            [tags_1.GIT_COMMIT_AUTHOR_EMAIL]: BUILDKITE_BUILD_AUTHOR_EMAIL,
            [tags_1.GIT_COMMIT_MESSAGE]: BUILDKITE_MESSAGE,
            [tags_1.CI_ENV_VARS]: JSON.stringify({
                BUILDKITE_BUILD_ID,
                BUILDKITE_JOB_ID,
            }),
        };
        if (extraTags.length) {
            tags[tags_1.CI_NODE_LABELS] = JSON.stringify(extraTags);
        }
        if (BUILDKITE_PULL_REQUEST && BUILDKITE_PULL_REQUEST !== 'false') {
            tags[tags_1.PR_NUMBER] = BUILDKITE_PULL_REQUEST;
            tags[tags_1.GIT_PULL_REQUEST_BASE_BRANCH] = BUILDKITE_PULL_REQUEST_BASE_BRANCH;
        }
    }
    if (env.BITRISE_BUILD_SLUG) {
        const { BITRISE_GIT_COMMIT, GIT_CLONE_COMMIT_HASH, BITRISEIO_GIT_BRANCH_DEST, BITRISE_GIT_BRANCH, BITRISE_BUILD_SLUG, BITRISE_TRIGGERED_WORKFLOW_ID, BITRISE_BUILD_NUMBER, BITRISE_BUILD_URL, BITRISE_SOURCE_DIR, GIT_REPOSITORY_URL: BITRISE_GIT_REPOSITORY_URL, BITRISE_GIT_TAG, BITRISE_GIT_MESSAGE, BITRISE_PULL_REQUEST, } = env;
        tags = {
            [tags_1.CI_PROVIDER_NAME]: exports.CI_ENGINES.BITRISE,
            [tags_1.CI_PIPELINE_ID]: BITRISE_BUILD_SLUG,
            [tags_1.CI_PIPELINE_NAME]: BITRISE_TRIGGERED_WORKFLOW_ID,
            [tags_1.CI_PIPELINE_NUMBER]: BITRISE_BUILD_NUMBER,
            [tags_1.CI_PIPELINE_URL]: BITRISE_BUILD_URL,
            [tags_1.GIT_SHA]: BITRISE_GIT_COMMIT || GIT_CLONE_COMMIT_HASH,
            [tags_1.GIT_REPOSITORY_URL]: BITRISE_GIT_REPOSITORY_URL,
            [tags_1.CI_WORKSPACE_PATH]: BITRISE_SOURCE_DIR,
            [tags_1.GIT_TAG]: BITRISE_GIT_TAG,
            [tags_1.GIT_BRANCH]: BITRISE_GIT_BRANCH,
            [tags_1.GIT_COMMIT_MESSAGE]: BITRISE_GIT_MESSAGE,
        };
        if (BITRISE_PULL_REQUEST) {
            tags[tags_1.PR_NUMBER] = BITRISE_PULL_REQUEST;
            tags[tags_1.GIT_PULL_REQUEST_BASE_BRANCH] = BITRISEIO_GIT_BRANCH_DEST;
        }
    }
    if (env.BITBUCKET_COMMIT) {
        const { BITBUCKET_REPO_FULL_NAME, BITBUCKET_BUILD_NUMBER, BITBUCKET_BRANCH, BITBUCKET_COMMIT, BITBUCKET_GIT_SSH_ORIGIN, BITBUCKET_GIT_HTTP_ORIGIN, BITBUCKET_TAG, BITBUCKET_PIPELINE_UUID, BITBUCKET_PR_ID, BITBUCKET_PR_DESTINATION_BRANCH, BITBUCKET_PR_DESTINATION_COMMIT, BITBUCKET_CLONE_DIR, } = env;
        const url = `https://bitbucket.org/${BITBUCKET_REPO_FULL_NAME}/addon/pipelines/home#!/results/${BITBUCKET_BUILD_NUMBER}`;
        tags = {
            [tags_1.CI_PROVIDER_NAME]: exports.CI_ENGINES.BITBUCKET,
            [tags_1.GIT_SHA]: BITBUCKET_COMMIT,
            [tags_1.CI_PIPELINE_NUMBER]: BITBUCKET_BUILD_NUMBER,
            [tags_1.CI_PIPELINE_NAME]: BITBUCKET_REPO_FULL_NAME,
            [tags_1.CI_JOB_URL]: url,
            [tags_1.CI_PIPELINE_URL]: url,
            [tags_1.GIT_BRANCH]: BITBUCKET_BRANCH,
            [tags_1.GIT_TAG]: BITBUCKET_TAG,
            [tags_1.GIT_REPOSITORY_URL]: BITBUCKET_GIT_SSH_ORIGIN || BITBUCKET_GIT_HTTP_ORIGIN,
            [tags_1.CI_WORKSPACE_PATH]: BITBUCKET_CLONE_DIR,
            [tags_1.CI_PIPELINE_ID]: BITBUCKET_PIPELINE_UUID && BITBUCKET_PIPELINE_UUID.replace(/{|}/gm, ''),
        };
        if (BITBUCKET_PR_ID) {
            tags[tags_1.PR_NUMBER] = BITBUCKET_PR_ID;
            tags[tags_1.GIT_PULL_REQUEST_BASE_BRANCH] = BITBUCKET_PR_DESTINATION_BRANCH;
            if (BITBUCKET_PR_DESTINATION_COMMIT) {
                tags[tags_1.GIT_PULL_REQUEST_BASE_BRANCH_SHA] = BITBUCKET_PR_DESTINATION_COMMIT;
            }
        }
    }
    if (env.CF_BUILD_ID) {
        const { CF_BUILD_ID, CF_PIPELINE_NAME, CF_BUILD_URL, CF_STEP_NAME, CF_BRANCH, CF_PULL_REQUEST_ID, CF_PULL_REQUEST_NUMBER, CF_PULL_REQUEST_TARGET, } = env;
        tags = {
            [tags_1.CI_PROVIDER_NAME]: exports.CI_ENGINES.CODEFRESH,
            [tags_1.CI_PIPELINE_ID]: CF_BUILD_ID,
            [tags_1.CI_PIPELINE_URL]: CF_BUILD_URL,
            [tags_1.CI_PIPELINE_NAME]: CF_PIPELINE_NAME,
            [tags_1.CI_JOB_NAME]: CF_STEP_NAME,
            [tags_1.GIT_BRANCH]: CF_BRANCH,
            [tags_1.CI_ENV_VARS]: JSON.stringify({ CF_BUILD_ID }),
        };
        const isTag = CF_BRANCH && CF_BRANCH.includes('tags/');
        const refKey = isTag ? tags_1.GIT_TAG : tags_1.GIT_BRANCH;
        const ref = (0, utils_1.normalizeRef)(CF_BRANCH);
        tags[refKey] = ref;
        if (CF_PULL_REQUEST_NUMBER || CF_PULL_REQUEST_ID) {
            tags[tags_1.PR_NUMBER] = CF_PULL_REQUEST_NUMBER || CF_PULL_REQUEST_ID;
            tags[tags_1.GIT_PULL_REQUEST_BASE_BRANCH] = CF_PULL_REQUEST_TARGET;
        }
    }
    if (env.TEAMCITY_VERSION) {
        const { BUILD_URL, TEAMCITY_BUILDCONF_NAME, TEAMCITY_PULLREQUEST_NUMBER, TEAMCITY_PULLREQUEST_TARGET_BRANCH } = env;
        tags = {
            [tags_1.CI_PROVIDER_NAME]: exports.CI_ENGINES.TEAMCITY,
            [tags_1.CI_JOB_URL]: BUILD_URL,
            [tags_1.CI_JOB_NAME]: TEAMCITY_BUILDCONF_NAME,
        };
        if (TEAMCITY_PULLREQUEST_NUMBER) {
            tags[tags_1.PR_NUMBER] = TEAMCITY_PULLREQUEST_NUMBER;
            tags[tags_1.GIT_PULL_REQUEST_BASE_BRANCH] = TEAMCITY_PULLREQUEST_TARGET_BRANCH;
        }
    }
    if (env.TF_BUILD) {
        const { BUILD_SOURCESDIRECTORY, BUILD_BUILDID, BUILD_DEFINITIONNAME, SYSTEM_TEAMFOUNDATIONSERVERURI, SYSTEM_TEAMPROJECTID, SYSTEM_JOBID, SYSTEM_TASKINSTANCEID, SYSTEM_PULLREQUEST_SOURCEBRANCH, BUILD_SOURCEBRANCH, BUILD_SOURCEBRANCHNAME, SYSTEM_PULLREQUEST_PULLREQUESTNUMBER, SYSTEM_PULLREQUEST_SOURCECOMMITID, SYSTEM_PULLREQUEST_SOURCEREPOSITORYURI, SYSTEM_PULLREQUEST_TARGETBRANCH, BUILD_REPOSITORY_URI, BUILD_SOURCEVERSION, BUILD_REQUESTEDFORID, BUILD_REQUESTEDFOREMAIL, BUILD_SOURCEVERSIONMESSAGE, SYSTEM_STAGEDISPLAYNAME, SYSTEM_JOBDISPLAYNAME, } = env;
        tags = {
            [tags_1.CI_PROVIDER_NAME]: exports.CI_ENGINES.AZURE,
            [tags_1.CI_PIPELINE_ID]: BUILD_BUILDID,
            [tags_1.CI_PIPELINE_NAME]: BUILD_DEFINITIONNAME,
            [tags_1.CI_PIPELINE_NUMBER]: BUILD_BUILDID,
            [tags_1.GIT_SHA]: SYSTEM_PULLREQUEST_SOURCECOMMITID || BUILD_SOURCEVERSION,
            [tags_1.CI_WORKSPACE_PATH]: BUILD_SOURCESDIRECTORY,
            [tags_1.GIT_REPOSITORY_URL]: SYSTEM_PULLREQUEST_SOURCEREPOSITORYURI || BUILD_REPOSITORY_URI,
            [tags_1.GIT_BRANCH]: SYSTEM_PULLREQUEST_SOURCEBRANCH || BUILD_SOURCEBRANCH || BUILD_SOURCEBRANCHNAME,
            [tags_1.GIT_COMMIT_AUTHOR_NAME]: BUILD_REQUESTEDFORID,
            [tags_1.GIT_COMMIT_AUTHOR_EMAIL]: BUILD_REQUESTEDFOREMAIL,
            [tags_1.GIT_COMMIT_MESSAGE]: BUILD_SOURCEVERSIONMESSAGE,
            [tags_1.CI_STAGE_NAME]: SYSTEM_STAGEDISPLAYNAME,
            [tags_1.CI_JOB_NAME]: SYSTEM_JOBDISPLAYNAME,
            [tags_1.CI_JOB_ID]: SYSTEM_JOBID,
            [tags_1.CI_ENV_VARS]: JSON.stringify({
                SYSTEM_TEAMPROJECTID,
                BUILD_BUILDID,
                SYSTEM_JOBID,
            }),
        };
        if (SYSTEM_TEAMFOUNDATIONSERVERURI && SYSTEM_TEAMPROJECTID && BUILD_BUILDID) {
            const baseUrl = `${SYSTEM_TEAMFOUNDATIONSERVERURI}${SYSTEM_TEAMPROJECTID}/_build/results?buildId=${BUILD_BUILDID}`;
            const pipelineUrl = baseUrl;
            const jobUrl = `${baseUrl}&view=logs&j=${SYSTEM_JOBID}&t=${SYSTEM_TASKINSTANCEID}`;
            tags = Object.assign(Object.assign({}, tags), { [tags_1.CI_PIPELINE_URL]: pipelineUrl, [tags_1.CI_JOB_URL]: jobUrl });
        }
        if (SYSTEM_PULLREQUEST_PULLREQUESTNUMBER) {
            tags[tags_1.PR_NUMBER] = SYSTEM_PULLREQUEST_PULLREQUESTNUMBER;
            tags[tags_1.GIT_PULL_REQUEST_BASE_BRANCH] = SYSTEM_PULLREQUEST_TARGETBRANCH === null || SYSTEM_PULLREQUEST_TARGETBRANCH === void 0 ? void 0 : SYSTEM_PULLREQUEST_TARGETBRANCH.replace('refs/heads/', '');
            tags[tags_1.GIT_HEAD_SHA] = SYSTEM_PULLREQUEST_SOURCECOMMITID;
        }
    }
    if (env.APPVEYOR) {
        const { APPVEYOR_REPO_NAME, APPVEYOR_REPO_PROVIDER, APPVEYOR_BUILD_FOLDER, APPVEYOR_BUILD_ID, APPVEYOR_BUILD_NUMBER, APPVEYOR_REPO_COMMIT, APPVEYOR_PULL_REQUEST_HEAD_COMMIT, APPVEYOR_PULL_REQUEST_HEAD_REPO_BRANCH, APPVEYOR_PULL_REQUEST_NUMBER, APPVEYOR_REPO_BRANCH, APPVEYOR_REPO_TAG_NAME, APPVEYOR_REPO_COMMIT_AUTHOR, APPVEYOR_REPO_COMMIT_AUTHOR_EMAIL, APPVEYOR_REPO_COMMIT_MESSAGE, APPVEYOR_REPO_COMMIT_MESSAGE_EXTENDED, } = env;
        const pipelineUrl = `https://ci.appveyor.com/project/${APPVEYOR_REPO_NAME}/builds/${APPVEYOR_BUILD_ID}`;
        tags = {
            [tags_1.CI_PROVIDER_NAME]: exports.CI_ENGINES.APPVEYOR,
            [tags_1.CI_PIPELINE_URL]: pipelineUrl,
            [tags_1.CI_PIPELINE_ID]: APPVEYOR_BUILD_ID,
            [tags_1.CI_PIPELINE_NAME]: APPVEYOR_REPO_NAME,
            [tags_1.CI_PIPELINE_NUMBER]: APPVEYOR_BUILD_NUMBER,
            [tags_1.CI_JOB_URL]: pipelineUrl,
            [tags_1.CI_WORKSPACE_PATH]: APPVEYOR_BUILD_FOLDER,
            [tags_1.GIT_COMMIT_AUTHOR_NAME]: APPVEYOR_REPO_COMMIT_AUTHOR,
            [tags_1.GIT_COMMIT_AUTHOR_EMAIL]: APPVEYOR_REPO_COMMIT_AUTHOR_EMAIL,
            [tags_1.GIT_COMMIT_MESSAGE]: `${APPVEYOR_REPO_COMMIT_MESSAGE || ''}\n${APPVEYOR_REPO_COMMIT_MESSAGE_EXTENDED || ''}`,
        };
        if (APPVEYOR_REPO_PROVIDER === 'github') {
            tags = Object.assign(Object.assign({}, tags), { [tags_1.GIT_REPOSITORY_URL]: `https://github.com/${APPVEYOR_REPO_NAME}.git`, [tags_1.GIT_SHA]: APPVEYOR_REPO_COMMIT, [tags_1.GIT_TAG]: APPVEYOR_REPO_TAG_NAME, [tags_1.GIT_BRANCH]: APPVEYOR_PULL_REQUEST_HEAD_REPO_BRANCH || APPVEYOR_REPO_BRANCH });
        }
        if (APPVEYOR_PULL_REQUEST_HEAD_REPO_BRANCH) {
            tags[tags_1.PR_NUMBER] = APPVEYOR_PULL_REQUEST_NUMBER;
            tags[tags_1.GIT_PULL_REQUEST_BASE_BRANCH] = (0, utils_1.normalizeRef)(APPVEYOR_REPO_BRANCH);
            tags[tags_1.GIT_HEAD_SHA] = APPVEYOR_PULL_REQUEST_HEAD_COMMIT;
        }
    }
    if (env.BUDDY) {
        const { BUDDY_PIPELINE_NAME, BUDDY_PIPELINE_ID, BUDDY_EXECUTION_ID, BUDDY_SCM_URL, BUDDY_EXECUTION_BRANCH, BUDDY_EXECUTION_TAG, BUDDY_EXECUTION_REVISION, BUDDY_EXECUTION_URL, BUDDY_EXECUTION_REVISION_MESSAGE, BUDDY_EXECUTION_REVISION_COMMITTER_NAME, BUDDY_EXECUTION_REVISION_COMMITTER_EMAIL, BUDDY_RUN_PR_NO, BUDDY_RUN_PR_BASE_BRANCH, } = env;
        tags = {
            [tags_1.CI_PROVIDER_NAME]: exports.CI_ENGINES.BUDDY,
            [tags_1.CI_PIPELINE_ID]: `${BUDDY_PIPELINE_ID || ''}/${BUDDY_EXECUTION_ID || ''}`,
            [tags_1.CI_PIPELINE_NAME]: BUDDY_PIPELINE_NAME,
            [tags_1.CI_PIPELINE_NUMBER]: `${BUDDY_EXECUTION_ID || ''}`,
            [tags_1.CI_PIPELINE_URL]: BUDDY_EXECUTION_URL,
            [tags_1.GIT_SHA]: BUDDY_EXECUTION_REVISION,
            [tags_1.GIT_BRANCH]: BUDDY_EXECUTION_BRANCH,
            [tags_1.GIT_TAG]: BUDDY_EXECUTION_TAG,
            [tags_1.GIT_REPOSITORY_URL]: BUDDY_SCM_URL,
            [tags_1.GIT_COMMIT_MESSAGE]: BUDDY_EXECUTION_REVISION_MESSAGE,
            [tags_1.GIT_COMMIT_COMMITTER_EMAIL]: BUDDY_EXECUTION_REVISION_COMMITTER_EMAIL,
            [tags_1.GIT_COMMIT_COMMITTER_NAME]: BUDDY_EXECUTION_REVISION_COMMITTER_NAME,
        };
        if (BUDDY_RUN_PR_NO) {
            tags[tags_1.PR_NUMBER] = BUDDY_RUN_PR_NO;
            tags[tags_1.GIT_PULL_REQUEST_BASE_BRANCH] = BUDDY_RUN_PR_BASE_BRANCH;
        }
    }
    if ((_g = env.CODEBUILD_INITIATOR) === null || _g === void 0 ? void 0 : _g.startsWith('codepipeline')) {
        const { CODEBUILD_BUILD_ARN, DD_ACTION_EXECUTION_ID, DD_PIPELINE_EXECUTION_ID, CODEBUILD_SOURCE_VERSION, CODEBUILD_RESOLVED_SOURCE_VERSION, CODEBUILD_WEBHOOK_BASE_REF, } = env;
        tags = {
            [tags_1.CI_PROVIDER_NAME]: exports.CI_ENGINES.AWSCODEPIPELINE,
            [tags_1.CI_JOB_ID]: DD_ACTION_EXECUTION_ID,
            [tags_1.CI_PIPELINE_ID]: DD_PIPELINE_EXECUTION_ID,
            [tags_1.CI_ENV_VARS]: JSON.stringify({ CODEBUILD_BUILD_ARN, DD_PIPELINE_EXECUTION_ID, DD_ACTION_EXECUTION_ID }),
        };
        const prMatch = (CODEBUILD_SOURCE_VERSION !== null && CODEBUILD_SOURCE_VERSION !== void 0 ? CODEBUILD_SOURCE_VERSION : '').match(/^pr\/(\d+)$/);
        if (prMatch) {
            tags[tags_1.PR_NUMBER] = prMatch === null || prMatch === void 0 ? void 0 : prMatch[1];
            tags[tags_1.GIT_PULL_REQUEST_BASE_BRANCH] = CODEBUILD_WEBHOOK_BASE_REF;
            tags[tags_1.GIT_HEAD_SHA] = CODEBUILD_RESOLVED_SOURCE_VERSION;
        }
    }
    if (tags[tags_1.CI_WORKSPACE_PATH]) {
        tags[tags_1.CI_WORKSPACE_PATH] = resolveTilde(tags[tags_1.CI_WORKSPACE_PATH]);
    }
    if (tags[tags_1.GIT_REPOSITORY_URL]) {
        tags[tags_1.GIT_REPOSITORY_URL] = (0, utils_1.filterSensitiveInfoFromRepository)(tags[tags_1.GIT_REPOSITORY_URL]);
    }
    if (tags[tags_1.GIT_TAG]) {
        tags[tags_1.GIT_TAG] = (0, utils_1.normalizeRef)(tags[tags_1.GIT_TAG]);
    }
    if (tags[tags_1.GIT_BRANCH]) {
        // Here we handle the case where GIT_BRANCH actually contains a tag
        const branch = tags[tags_1.GIT_BRANCH] || '';
        if (branch.startsWith('tags/') || branch.includes('/tags/')) {
            if (!tags[tags_1.GIT_TAG]) {
                tags[tags_1.GIT_TAG] = (0, utils_1.normalizeRef)(branch);
            }
            tags[tags_1.GIT_BRANCH] = '';
        }
        else {
            tags[tags_1.GIT_BRANCH] = (0, utils_1.normalizeRef)(branch);
        }
    }
    return (0, utils_1.removeEmptyValues)(tags);
};
exports.getCISpanTags = getCISpanTags;
const getCIMetadata = (tagSizeLimits) => {
    const tags = Object.assign(Object.assign(Object.assign({}, (0, exports.getCISpanTags)()), (0, user_provided_git_1.getUserCISpanTags)()), (0, user_provided_git_1.getUserGitSpanTags)());
    if (!tags || !Object.keys(tags).length) {
        return;
    }
    if (tagSizeLimits) {
        for (const key of Object.keys(tagSizeLimits)) {
            const tagToLimit = key;
            const originalTag = tags[tagToLimit];
            if (!!originalTag) {
                tags[tagToLimit] = originalTag.substring(0, tagSizeLimits[tagToLimit]);
            }
        }
    }
    const metadata = {
        ci: (0, utils_1.removeUndefinedValues)({
            job: (0, utils_1.removeUndefinedValues)({
                id: tags[tags_1.CI_JOB_ID],
                name: tags[tags_1.CI_JOB_NAME],
                url: tags[tags_1.CI_JOB_URL],
            }),
            pipeline: (0, utils_1.removeUndefinedValues)({
                id: tags[tags_1.CI_PIPELINE_ID],
                name: tags[tags_1.CI_PIPELINE_NAME],
                number: parseNumber(tags[tags_1.CI_PIPELINE_NUMBER]),
                url: tags[tags_1.CI_PIPELINE_URL],
            }),
            provider: (0, utils_1.removeUndefinedValues)({
                name: tags[tags_1.CI_PROVIDER_NAME],
            }),
            stage: (0, utils_1.removeUndefinedValues)({
                name: tags[tags_1.CI_STAGE_NAME],
            }),
            workspace_path: tags[tags_1.CI_WORKSPACE_PATH],
        }),
        git: (0, utils_1.removeUndefinedValues)({
            branch: tags[tags_1.GIT_BRANCH],
            commit: (0, utils_1.removeUndefinedValues)({
                author: (0, utils_1.removeUndefinedValues)({
                    date: tags[tags_1.GIT_COMMIT_AUTHOR_DATE],
                    email: tags[tags_1.GIT_COMMIT_AUTHOR_EMAIL],
                    name: tags[tags_1.GIT_COMMIT_AUTHOR_NAME],
                }),
                committer: (0, utils_1.removeUndefinedValues)({
                    date: tags[tags_1.GIT_COMMIT_COMMITTER_DATE],
                    email: tags[tags_1.GIT_COMMIT_COMMITTER_EMAIL],
                    name: tags[tags_1.GIT_COMMIT_COMMITTER_NAME],
                }),
                message: tags[tags_1.GIT_COMMIT_MESSAGE],
                sha: tags[tags_1.GIT_SHA],
            }),
            repository_url: tags[tags_1.GIT_REPOSITORY_URL],
            tag: tags[tags_1.GIT_TAG],
        }),
    };
    return metadata;
};
exports.getCIMetadata = getCIMetadata;
const parseNumber = (numberStr) => {
    if (numberStr) {
        const number = parseInt(numberStr, 10);
        return isFinite(number) ? number : undefined;
    }
};
const getCIEnv = () => {
    if (process.env.CIRCLECI) {
        return {
            ciEnv: filterEnv(['CIRCLE_WORKFLOW_ID', 'CIRCLE_BUILD_NUM']),
            provider: 'circleci',
        };
    }
    if (process.env.GITLAB_CI) {
        return {
            ciEnv: filterEnv(['CI_PROJECT_URL', 'CI_PIPELINE_ID', 'CI_JOB_ID', 'CI_JOB_STAGE']),
            provider: 'gitlab',
        };
    }
    if (process.env.GITHUB_ACTIONS || process.env.GITHUB_ACTION) {
        return {
            ciEnv: filterEnv([
                'GITHUB_SERVER_URL',
                'GITHUB_REPOSITORY',
                'GITHUB_RUN_ID',
                'GITHUB_RUN_ATTEMPT',
                'GITHUB_JOB',
                exports.envDDGithubJobName,
            ]),
            provider: 'github',
        };
    }
    if (process.env.BUILDKITE) {
        return {
            ciEnv: filterEnv(['BUILDKITE_BUILD_ID', 'BUILDKITE_JOB_ID']),
            provider: 'buildkite',
        };
    }
    if (process.env.TEAMCITY_VERSION) {
        return {
            ciEnv: filterEnv(['DATADOG_BUILD_ID']),
            provider: 'teamcity',
        };
    }
    if (process.env.JENKINS_URL) {
        return {
            ciEnv: filterEnv(['DD_CUSTOM_PARENT_ID', envJenkinsCustomStageID, 'DD_CUSTOM_TRACE_ID']),
            provider: 'jenkins',
        };
    }
    if (process.env.TF_BUILD) {
        return {
            ciEnv: filterEnv([
                'SYSTEM_TEAMPROJECTID',
                'BUILD_BUILDID',
                'SYSTEM_JOBID',
                'SYSTEM_STAGENAME',
                'SYSTEM_STAGEATTEMPT',
            ]),
            provider: 'azurepipelines',
        };
    }
    throw new Error('Only providers [GitHub, GitLab, CircleCI, Buildkite, Jenkins, TeamCity, AzurePipelines] are supported');
};
exports.getCIEnv = getCIEnv;
const isCI = () => {
    return 'CI' in process.env || (0, exports.getCIProvider)() !== 'unknown';
};
exports.isCI = isCI;
const getCIProvider = () => {
    var _a;
    if (process.env.CIRCLECI) {
        return exports.CI_ENGINES.CIRCLECI;
    }
    if (process.env.GITLAB_CI) {
        return exports.CI_ENGINES.GITLAB;
    }
    if (process.env.GITHUB_ACTIONS || process.env.GITHUB_ACTION) {
        return exports.CI_ENGINES.GITHUB;
    }
    if (process.env.BUILDKITE) {
        return exports.CI_ENGINES.BUILDKITE;
    }
    if (process.env.BUDDY) {
        return exports.CI_ENGINES.BUDDY;
    }
    if (process.env.TEAMCITY_VERSION) {
        return exports.CI_ENGINES.TEAMCITY;
    }
    if (process.env.JENKINS_URL) {
        return exports.CI_ENGINES.JENKINS;
    }
    if (process.env.TF_BUILD) {
        return exports.CI_ENGINES.AZURE;
    }
    if (process.env.CF_BUILD_ID) {
        return exports.CI_ENGINES.CODEFRESH;
    }
    if (process.env.APPVEYOR) {
        return exports.CI_ENGINES.APPVEYOR;
    }
    if (process.env.BITBUCKET_COMMIT) {
        return exports.CI_ENGINES.BITBUCKET;
    }
    if (process.env.BITRISE_BUILD_SLUG) {
        return exports.CI_ENGINES.BITRISE;
    }
    if ((_a = process.env.CODEBUILD_INITIATOR) === null || _a === void 0 ? void 0 : _a.startsWith('codepipeline')) {
        return exports.CI_ENGINES.AWSCODEPIPELINE;
    }
    return 'unknown';
};
exports.getCIProvider = getCIProvider;
const filterEnv = (values) => {
    const ciEnvs = {};
    const requiredMissing = [];
    values.forEach((envKey) => {
        const envValue = process.env[envKey];
        if (envValue) {
            ciEnvs[envKey] = envValue;
        }
        else if (!envAllowedToBeMissing.includes(envKey)) {
            requiredMissing.push(envKey);
        }
    });
    if (requiredMissing.length > 0) {
        // Get the missing values for better error
        throw new Error(`Missing environment variables [${requiredMissing.toString()}]`);
    }
    return ciEnvs;
};
const isInteractive = ({ stream = process.stdout } = {}) => {
    return Boolean(!('CI' in process.env) && process.env.TERM !== 'dumb' && stream && stream.isTTY);
};
exports.isInteractive = isInteractive;
const shouldGetGithubJobDisplayName = () => {
    return (0, exports.getCIProvider)() === exports.CI_ENGINES.GITHUB && process.env.DD_GITHUB_JOB_NAME === undefined;
};
exports.shouldGetGithubJobDisplayName = shouldGetGithubJobDisplayName;
const shouldGetGithubJobID = () => {
    return (0, exports.getCIProvider)() === exports.CI_ENGINES.GITHUB;
};
exports.shouldGetGithubJobID = shouldGetGithubJobID;
const isGithubWindowsRunner = () => {
    const os = process.env.RUNNER_OS;
    if (!os) {
        return false;
    }
    return os.toLowerCase() === 'windows';
};
exports.isGithubWindowsRunner = isGithubWindowsRunner;
const createGithubLogCache = () => ({
    workerLogFilesResolved: false,
    workerLogFiles: undefined,
    targetLogFilesResolved: false,
    targetLogFiles: [],
    fileContents: new Map(),
});
exports.createGithubLogCache = createGithubLogCache;
/** Reads a diagnostic log file, serving from (and populating) `cache` when provided. */
const readLogFile = (filePath, cache) => {
    const cached = cache === null || cache === void 0 ? void 0 : cache.fileContents.get(filePath);
    if (cached !== undefined) {
        return cached;
    }
    const content = fs_1.default.readFileSync(filePath, 'utf-8');
    cache === null || cache === void 0 ? void 0 : cache.fileContents.set(filePath, content);
    return content;
};
const getGithubWorkerLogFiles = (context, cache) => {
    if (cache === null || cache === void 0 ? void 0 : cache.workerLogFilesResolved) {
        return cache.workerLogFiles;
    }
    const result = computeGithubWorkerLogFiles(context);
    if (cache) {
        cache.workerLogFilesResolved = true;
        cache.workerLogFiles = result;
    }
    return result;
};
const computeGithubWorkerLogFiles = (context) => {
    let foundDiagDir = '';
    let workerLogFiles = [];
    let wellKnownDirs = expandDiagnosticDirCandidates([
        ...getGithubDiagnosticDirsFromEnv(),
        ...exports.githubWellKnownDiagnosticDirPatternsUnix,
        ...exports.githubWellKnownDiagnosticDirsUnix,
    ]);
    if ((0, exports.isGithubWindowsRunner)()) {
        wellKnownDirs = expandDiagnosticDirCandidates([
            ...getGithubDiagnosticDirsFromEnv(),
            ...exports.githubWellKnownDiagnosticDirPatternsWin,
            ...exports.githubWellKnownDiagnosticDirsWin,
        ]);
    }
    // Iterate through well known directories to check for worker logs
    for (const currentDir of wellKnownDirs) {
        try {
            const files = fs_1.default.readdirSync(currentDir, { withFileTypes: true });
            const potentialLogs = files
                .filter((file) => file.isFile() && file.name.startsWith('Worker_') && file.name.endsWith('.log'))
                .map((file) => file.name);
            if (potentialLogs.length > 0) {
                foundDiagDir = currentDir;
                workerLogFiles = potentialLogs;
                break;
            }
        }
        catch (error) {
            // If the directory does not exist, just try the next one
            if (error instanceof Error && 'code' in error && error.code === 'ENOENT') {
                continue;
            }
            let errMessage = 'error reading GitHub diagnostic log files';
            if (error instanceof Error) {
                errMessage += `: ${error.message}`;
            }
            else {
                errMessage += `: ${String(error)}`;
            }
            context.stderr.write(`${chalk_1.default.yellow.bold('[WARNING]')} ${errMessage}`);
            return;
        }
    }
    if (workerLogFiles.length === 0 || foundDiagDir === '') {
        context.stderr.write(`${chalk_1.default.yellow.bold('[WARNING]')} could not find GitHub diagnostic log files (Worker_*.log). Looked in: ${wellKnownDirs.join(', ')}`);
        return;
    }
    return [foundDiagDir, workerLogFiles];
};
/**
 * Narrows the list of Worker log files to the one belonging to the current job.
 *
 * Worker log filenames contain a timestamp (Worker_YYYYMMDD-HHMMSS-utc.log), so
 * alphabetical order equals chronological order. Logs are always returned
 * newest-first so that the caller's iteration naturally encounters the current
 * job's log before any earlier ones — correct on both ephemeral and non-ephemeral
 * (multi) runners regardless of the strategy used.
 *
 * Primary strategy (runner >= v2.331.0, feature-flag gated):
 *   ACTIONS_ORCHESTRATION_ID is set by the runner from the system.orchestrationId
 *   variable in the job request message. That variable is serialized into the Worker
 *   log as part of the job message JSON. planId is a GUID shared by all jobs in the
 *   same workflow run, so the full orchestration ID is needed for a unique match:
 *     Non-matrix job:          <planId>.<yaml-job-key>.__default
 *     Single-dimension matrix: <planId>.<yaml-job-key>.<matrix-value>
 *     Multi-dimension matrix:  <planId>.<yaml-job-key>.<val1>.<val2>[...]
 *
 * Fallback (runner < v2.331.0 or ACTIONS_ORCHESTRATION_ID absent/unmatched):
 *   Return all logs newest-first. The caller iterates until it finds a jobDisplayName,
 *   which on a single-job runner is immediate, and on a multi-runner is the current
 *   job's (most recent) log.
 */
const getTargetWorkerLogFiles = (context, foundDiagDir, workerLogFiles, cache) => {
    if (cache === null || cache === void 0 ? void 0 : cache.targetLogFilesResolved) {
        return cache.targetLogFiles;
    }
    const result = computeTargetWorkerLogFiles(context, foundDiagDir, workerLogFiles, cache);
    if (cache) {
        cache.targetLogFilesResolved = true;
        cache.targetLogFiles = result;
    }
    return result;
};
const computeTargetWorkerLogFiles = (context, foundDiagDir, workerLogFiles, cache) => {
    // Always sort newest-first so the fallback iteration is in the right order.
    const sortedNewestFirst = [...workerLogFiles].sort().reverse();
    const orchestrationId = process.env.ACTIONS_ORCHESTRATION_ID;
    if (orchestrationId) {
        for (const logFile of sortedNewestFirst) {
            const filePath = upath_1.default.join(foundDiagDir, logFile);
            const content = readLogFile(filePath, cache);
            if (content.includes('"system.orchestrationId":') && content.includes(`"${orchestrationId}"`)) {
                context.stdout.write(`Found Worker log via system.orchestrationId for ${orchestrationId}: ${logFile}\n`);
                return [logFile];
            }
        }
        context.stderr.write(`${chalk_1.default.yellow.bold('[WARNING]')} Could not find Worker log via system.orchestrationId for ${orchestrationId}, checking all logs\n`);
    }
    return sortedNewestFirst;
};
const getGithubJobAttributeFromLogFiles = (context, foundDiagDir, workerLogFiles, jobAttributeRegex, cache) => {
    const logsToCheck = getTargetWorkerLogFiles(context, foundDiagDir, workerLogFiles, cache);
    for (const logFile of logsToCheck) {
        const filePath = upath_1.default.join(foundDiagDir, logFile);
        const content = readLogFile(filePath, cache);
        const match = content.match(jobAttributeRegex);
        if (match && match[1]) {
            const unescapedAttribute = unescapeJsonString(match[1]);
            return unescapedAttribute;
        }
    }
    return;
};
/**
 * Extracts the job display name from the GitHub Actions diagnostic log files.
 *
 * In Github Actions, the GITHUB_JOB environment variable points to the job name
 * defined in the workflow file, but users can change the name by using the 'name'
 * property or matrix jobs. In this case the correlation will not work as GITHUB_JOB
 * contains a 'fake' job name.
 *
 * Previous to this, users had to set manually the DD_GITHUB_JOB_NAME env variable
 * pointing to the real job name.
 *
 * The diagnostic log files from the runner contain the display name, which enables
 * the correlation to happen without manually setting the environment variable.
 *
 * @returns The job display name, or undefined if not found
 */
const getGithubJobNameFromLogs = (context, cache) => {
    if (!(0, exports.shouldGetGithubJobDisplayName)()) {
        return;
    }
    context.stdout.write('Determining GitHub job name\n');
    const result = getGithubWorkerLogFiles(context, cache);
    if (!result) {
        return;
    }
    const [foundDiagDir, workerLogFiles] = result;
    const jobDisplayName = getGithubJobAttributeFromLogFiles(context, foundDiagDir, workerLogFiles, githubJobDisplayNameRegex, cache);
    if (!jobDisplayName) {
        context.stderr.write(`${chalk_1.default.yellow.bold('[WARNING]')} could not find "jobDisplayName" attribute in GitHub diagnostic logs`);
    }
    else {
        context.stdout.write(`Successfully extracted job name: ${jobDisplayName}\n`);
        return jobDisplayName;
    }
};
exports.getGithubJobNameFromLogs = getGithubJobNameFromLogs;
/**
 * Enriches `ciEnv` with GitHub-specific info from diagnostic logs based on the CI level.
 * - step: extracts job display name + step index
 * - job: extracts job display name
 * - pipeline/stage: no-op
 */
const enrichCIEnvFromGithubLogs = (context, level, ciEnv, cache) => {
    switch (level) {
        case exports.CI_LEVELS.STEP: {
            const stepInfo = (0, exports.getGithubStepInfoFromLogs)(context, cache);
            if (!ciEnv[exports.envDDGithubJobName]) {
                ciEnv[exports.envDDGithubJobName] = stepInfo.jobDisplayName;
            }
            ciEnv[exports.envDDGithubStepIndex] = String(stepInfo.stepIndex);
            break;
        }
        case exports.CI_LEVELS.JOB: {
            const jobName = (0, exports.getGithubJobNameFromLogs)(context, cache);
            if (jobName) {
                ciEnv[exports.envDDGithubJobName] = jobName;
            }
            break;
        }
        default:
            break;
    }
};
exports.enrichCIEnvFromGithubLogs = enrichCIEnvFromGithubLogs;
/**
 * Sends the same payload to each requested CI level, one request per level.
 *
 * Shared by the `tag` and `measure` commands. Each level is enriched on its own
 * copy of `ciEnv` (so e.g. the step index never leaks into the job request).
 *
 * Failure handling mirrors the original single-level behavior:
 * - A setup/config error — a missing API key, or GitHub diagnostic logs that
 *   cannot be located — is thrown and propagates to the caller's outer catch,
 *   making it fatal regardless of `--no-fail`. The thrown error is annotated
 *   with the failing level so the report says which one broke.
 * - A request that completes but reports a non-zero status sets the returned
 *   flag and the loop continues; the caller decides whether `--no-fail` turns
 *   it into a success.
 *
 * A single `GithubLogCache` lives for the duration of the loop so the GitHub
 * diagnostic logs are located and read at most once even when several levels
 * need them (e.g. `--level job,step`).
 *
 * Returns `true` if any level reported a non-zero status. Callers own the
 * `--no-fail`/success messaging and exit code based on this flag.
 */
const processLevels = (context, levels, ciEnv, sendForLevel) => __awaiter(void 0, void 0, void 0, function* () {
    const cache = (0, exports.createGithubLogCache)();
    let anyFailed = false;
    for (const level of levels) {
        let exitStatus;
        try {
            const levelEnv = Object.assign({}, ciEnv);
            (0, exports.enrichCIEnvFromGithubLogs)(context, level, levelEnv, cache);
            exitStatus = yield sendForLevel(levelEnv, exports.LEVEL_TO_NUMBER[level]);
        }
        catch (error) {
            // Re-throw annotated with the level. The command's outer catch reports it
            // and returns a non-zero exit code even under --no-fail, matching the
            // original single-level behavior where setup/config throws were fatal.
            throw new Error(`level '${level}': ${error.message}`);
        }
        if (exitStatus !== 0) {
            anyFailed = true;
            context.stderr.write(`${chalk_1.default.red.bold('[ERROR]')} failed to send for level '${level}'\n`);
        }
    }
    return anyFailed;
});
exports.processLevels = processLevels;
/**
 * Extracts the job display name and step index from GitHub Actions diagnostic logs.
 *
 * To avoid parsing the full Job message JSON (~26KB), we:
 * 1. Use the existing regex for `jobDisplayName`
 * 2. Extract only the `"steps": [...]` array from the Job message via bracket-depth tracking
 * 3. Parse just that array and match `contextName` against `GITHUB_ACTION`
 */
const getGithubStepInfoFromLogs = (context, cache) => {
    if ((0, exports.getCIProvider)() !== exports.CI_ENGINES.GITHUB) {
        throw new Error('Step level is only supported for GitHub Actions');
    }
    const githubAction = process.env.GITHUB_ACTION;
    if (!githubAction) {
        throw new Error('GITHUB_ACTION environment variable is not set, cannot determine step index');
    }
    context.stdout.write('Determining GitHub step info from diagnostic logs\n');
    const result = getGithubWorkerLogFiles(context, cache);
    if (!result) {
        throw new Error('Could not find GitHub diagnostic log files, cannot determine step index');
    }
    const [foundDiagDir, workerLogFiles] = result;
    const logsToCheck = getTargetWorkerLogFiles(context, foundDiagDir, workerLogFiles, cache);
    for (const logFile of logsToCheck) {
        const filePath = upath_1.default.join(foundDiagDir, logFile);
        const content = readLogFile(filePath, cache);
        // Extract jobDisplayName using the existing regex
        const displayNameMatch = content.match(githubJobDisplayNameRegex);
        if (!displayNameMatch || !displayNameMatch[1]) {
            continue;
        }
        const jobDisplayName = unescapeJsonString(displayNameMatch[1]);
        // Extract just the "steps" array from the Job message and find the matching step
        const stepIndex = getStepIndexFromLog(content, githubAction);
        if (stepIndex === -1) {
            continue;
        }
        context.stdout.write(`Successfully extracted step info: jobDisplayName=${jobDisplayName}, stepIndex=${stepIndex}\n`);
        return { jobDisplayName, stepIndex };
    }
    throw new Error('Could not find step info in GitHub diagnostic logs, cannot determine step index');
};
exports.getGithubStepInfoFromLogs = getGithubStepInfoFromLogs;
/**
 * Finds the "steps" array inside the Job message section of the log,
 * parses only that array, and returns the 0-based index of the step
 * whose `contextName` matches `githubAction`. Returns -1 if not found.
 */
const getStepIndexFromLog = (content, githubAction) => {
    // Scope to the Job message section
    const jobMessageIdx = content.indexOf('Job message:');
    if (jobMessageIdx === -1) {
        return -1;
    }
    // Find "steps" key followed by an array within the Job message
    const stepsKeyIdx = content.indexOf('"steps"', jobMessageIdx);
    if (stepsKeyIdx === -1) {
        return -1;
    }
    const bracketStart = content.indexOf('[', stepsKeyIdx);
    if (bracketStart === -1) {
        return -1;
    }
    const steps = extractJsonArray(content, bracketStart);
    if (!steps) {
        return -1;
    }
    return steps.findIndex((step) => {
        if (typeof step !== 'object' || !step) {
            return false;
        }
        const contextName = step.contextName;
        return typeof contextName === 'string' && contextName === githubAction;
    });
};
/**
 * Extracts a JSON array from `content` starting at `bracketStart`
 * by tracking bracket depth to find the matching `]`, then parsing
 * only that substring. Returns undefined if parsing fails.
 */
const extractJsonArray = (content, bracketStart) => {
    let depth = 0;
    for (let i = bracketStart; i < content.length; i++) {
        if (content[i] === '[') {
            depth++;
        }
        else if (content[i] === ']') {
            depth--;
        }
        if (depth === 0) {
            try {
                const parsed = JSON.parse(content.substring(bracketStart, i + 1));
                return Array.isArray(parsed) ? parsed : undefined;
            }
            catch (_a) {
                return undefined;
            }
        }
    }
    return undefined;
};
const getGithubJobIDFromLogs = (context) => {
    if (!(0, exports.shouldGetGithubJobID)()) {
        return;
    }
    context.stdout.write('Determining GitHub job ID\n');
    const result = getGithubWorkerLogFiles(context);
    if (!result) {
        return;
    }
    const [foundDiagDir, workerLogFiles] = result;
    const jobID = getGithubJobAttributeFromLogFiles(context, foundDiagDir, workerLogFiles, githubJodIDRegex);
    if (!jobID) {
        context.stderr.write(`${chalk_1.default.yellow.bold('[WARNING]')} could not find "jobID" attribute in GitHub diagnostic logs`);
    }
    else {
        context.stdout.write(`Successfully extracted job ID: ${jobID}\n`);
        return jobID;
    }
};
exports.getGithubJobIDFromLogs = getGithubJobIDFromLogs;
//# sourceMappingURL=ci.js.map